(function () {
  const cityCollectionUrls = {
    'San Diego': '/collections/san-diego',
    'Denver': '/collections/denver',
    'Washington DC': '/collections/washington',
    'San Francisco': '/collections/san-francisco',
    'Los Angeles': '/collections/los-angeles',
    'Las Vegas': '/collections/las-vegas',
    'New York': '/collections/new-york'
  };

  function mapCityCollectionCards() {
    document.querySelectorAll('.gpt-city-shop .gpt-city-collection-card').forEach(function (card) {
      const heading = card.querySelector('h3');
      if (!heading) return;
      const city = heading.textContent.trim();
      const url = cityCollectionUrls[city];
      if (url) card.setAttribute('href', url);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mapCityCollectionCards);
  } else {
    mapCityCollectionCards();
  }

  /* setupCityCovers() runs from the homepage polish script; run once more
     shortly after load so the links are correct even if the cards are rebuilt. */
  setTimeout(mapCityCollectionCards, 800);
})();
